const mutations = {
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
}

export default mutations
